import designerItem from './designerItem';

export default {
  template: '#designer_area',
  components: {
    designerItem,
  },
  props: ['side'],
  events: {
    'item-unselect': function() {
      this.overflow = 'hidden';
    },
    'item-select': function() {
      this.overflow = 'visible';
    },
    'draft-loaded': function() {
      var that = this,
        draftInfo = this.$root.campaignData,
        sides = ['front', 'back'],
        mainProduct = draftInfo.mainProduct;

      _.each(sides, function(side) {
        that.$root.$set('designerItems.' + side, mainProduct[side].designerItems);
        that.$root.elementsIndex[side] = mainProduct[side].designerItems.length;
      });


      if (this.side == 'front') {
        var p = [];
        _.each(this.$root.product_categories, function(category) {
          var product = _.find(category.category_products, function(cp) {
            return cp.products.id == mainProduct.product_id;
          });
          if (product)
            p.push(product);
        });
        var product = this.$root.parseProduct(p[0]);
        this.$root.selectProduct(product, false);
        this.$root.currentColor = mainProduct.currentColor;

        helpers.hideProcessing();
        this.$nextTick(function() {
          that.$root.trackImageIdentifierforCS = true;
        })
      }

    },
    'on-product-select': function(selectedProduct) {
      if (selectedProduct.product.sublimation == true) {
        if ($.inArray(selectedProduct.product.product_type, ["CANVAS", "TOWELS", "MATS", "FLAG", "POSTER", "MASK"]) > -1) {
          $('.sublimation-image').addClass('no-mouse-events');
          $('.sublimation-image').draggable('disable');
        } else {
          $('.sublimation-image').removeClass('no-mouse-events');
          $('.sublimation-image').draggable('enable');
        }
      }
    }
  },
  data: function() {
    return {
      overflow: 'hidden',
      sublimationImageStyle: {
        left: 0,
        top: 0,
        height: 0,
        width: 0,
        'z-index': 1
      },
    };
  },
  computed: {
    designerItems: function() {
      return this.side == 'front' ? this.$root.designerItems.front : this.$root.designerItems.back;
    },
    heatherBackgroundExists() {
      if (!!this.$root.hoverDesignerColor) {
        return !!this.$root.hoverDesignerColor.heather_image_url;
      }
      return !!this.$root.currentColor.heather_image_url;
    },
    heatherBackgroundURL() {
      if (!!this.$root.hoverDesignerColor) {
        return (!!this.$root.hoverDesignerColor.heather_image_url) ? this.$root.hoverDesignerColor.heather_image_url : '';
      }
      return (!!this.$root.currentColor.heather_image_url) ? this.$root.currentColor.heather_image_url : '';
    }
  },
  ready: function() {
    var that = this,
      sublimationImageElement = $('.sublimation-image'),
      bleedAreaElement = $('[class*="view-sublimation"] .bleed-area'),
      modelImageElement = $('[class*="view-sublimation"] .modelImage');

    sublimationImageElement.draggable({
      cursor: 'move',
      drag: function(event, ui) {
        if (that.$root.designerItems[that.$root.currentSide].length > 0)
          that.setSublimationImageStyle(ui.position.left, ui.position.top, that.$root.currentSide);
      },
      stop: function() {
        if (that.$root.designerItems[that.$root.currentSide].length > 0)
          that.bringSublimationImageToFront(that.$root.currentSide);
      }
    });

    sublimationImageElement.on('mouseup', function(e) {
      if ($('.sublimation-image').hasClass('no-mouse-events') === false)
        $('.view-sublimation-front').find('.modelImage').trigger('mouseup', false);
    });

    bleedAreaElement.on('mouseup', function(e, status) {
      if (status !== true) {
        if ($('.sublimation-image').hasClass('no-mouse-events') === false)
          if (that.$root.designerItems[that.$root.currentSide].length > 0)
            that.bringSublimationImageToFront(that.$root.currentSide);
      }
    });

    bleedAreaElement.on('mousedown', function(e) {
      if ($('.sublimation-image').hasClass('no-mouse-events') === false)
        if (that.$root.designerItems[that.$root.currentSide].length > 0)
          that.sendSublimationImageToBack(that.$root.currentSide, e);
    });

    modelImageElement.on('mouseup', function(e, status) {
      if (status !== true) {
        if ($('.sublimation-image').hasClass('no-mouse-events') === false)
          if (that.$root.designerItems[that.$root.currentSide].length > 0)
            that.bringSublimationImageToFront(that.$root.currentSide);
      }
    });

    modelImageElement.on('mousedown', function(e) {
      if ($('.sublimation-image').hasClass('no-mouse-events') === false)
        if (that.$root.designerItems[that.$root.currentSide].length > 0)
          that.sendSublimationImageToBack(that.$root.currentSide, e);
    });
  },
  methods: {
    isCurrentSide: function(side) {
      return side == this.$root.currentSide;
    },
    getAreaStyle: function(side) {
      var productObj = this.$root.selectedProduct;
      if (productObj != null) {
        if (side == 'front') {
          return {
            height: productObj.dimensions.front.offsets.height,
            width: productObj.dimensions.front.offsets.width,
            left: productObj.dimensions.front.offsets.left,
            top: productObj.dimensions.front.offsets.top,
            'z-index': 1,
            overflow: this.overflow
          };
        } else {
          return {
            height: productObj.dimensions.back.offsets.height,
            width: productObj.dimensions.back.offsets.width,
            left: productObj.dimensions.back.offsets.left,
            top: productObj.dimensions.back.offsets.top,
            'z-index': 1,
            overflow: this.overflow
          };
        }
      }
    },
    getImageStyle: function(side) {
      var productObj = this.$root.selectedProduct;
      if (productObj != null) {
        if (side == 'front') {
          return {
            width: productObj.dimensions.front.image.width,
            height: productObj.dimensions.front.image.height,
            top: '0px',
            left: '0px',
            'z-index': this.isSublimationProduct() == 1 ? 2 : ''
          };
        } else {
          return {
            width: productObj.dimensions.back.image.width,
            height: productObj.dimensions.back.image.height,
            top: '0px',
            left: '0px',
            'z-index': this.isSublimationProduct() == 1 ? 2 : 0
          };
        }
      }
    },
    getProductImage: function(side) {
      var productObj = this.$root.selectedProduct;
      if (productObj)
        return (side == 'front' ? this.$root.getDesignerHelper().imagePath + '' + productObj.image.front.original : (this.$root.selectedProduct.product.back_view == "SHOW" ? this.$root.getDesignerHelper().imagePath + '' + productObj.image.back.original : ''));
      else
        return '';
    },
    getNegativeAreaStyle: function(side) {
      var selectedProductObj = this.$root.selectedProduct;
      if (selectedProductObj) {
        var productObj = selectedProductObj.product;
        if (productObj)
          if (side == 'front') {
            if (productObj.mock_id == -1) {
              return {
                width: productObj.exclude_width + 'px',
                height: productObj.exclude_height + 'px',
                top: productObj.exclude_top + 'px',
                left: productObj.exclude_left + 'px',
                'background-color': '#FF0000',
                position: 'absolute',
                'z-index': 2,
                display: 'inline-block',
                border: '1px red dotted',
                opacity: 0.7
              };
            } else {
              var mock_index = selectedProductObj.mock_index,
                mockObj = productObj.products_mocks[mock_index];

              if (mockObj)
                return {
                  width: mockObj.exclude_width + 'px',
                  height: mockObj.exclude_height + 'px',
                  top: mockObj.exclude_top + 'px',
                  left: mockObj.exclude_left + 'px',
                  'background-color': '#FF0000',
                  position: 'absolute',
                  'z-index': 2,
                  display: 'inline-block',
                  border: '1px red dotted',
                  opacity: 0.7
                };
              else
                return '';
            }
          }
        else
          return '';
        else return '';
      } else {
        return '';
      }
    },
    getDesignBackgroundColor: function() {
      return {
        'background-color': this.$root.hoverDesignerColor ? this.$root.hoverDesignerColor.hex : this.$root.currentColor.hex
      }
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    },
    getSublimationImage: function(side) {
      if (this.isSublimationProduct())
        if (this.$root.designerItems[side].length > 0)
          return this.$root.designerItems[side][0].value;
    },
    getSublimationImageStyle: function(side) {
      if (this.$root.designerItems[side].length > 0) {
        var left = this.$root.designerItems[side][0].span.left,
          top = this.$root.designerItems[side][0].span.top;
        return {
          left: left.toString().indexOf('px') == -1 ? left + 'px' : left,
          top: top.toString().indexOf('px') == -1 ? top + 'px' : top,
          height: `${this.getSublimationImageHeight(side)}px` || '0px',
          width: `${this.getSublimationImageWidth(side)}px` || '0px',
          'z-index': 1
        };
      } else {
        return {
          left: '0px',
          top: '0px',
          width: '0px',
          height: '0px',
          'z-index': 1
        };
      }
    },
    getResizableContainer: function(side) {
      if (this.$root.designerItems[side].length > 0)
        return {
          left: this.$root.designerItems[side][0].span.left,
          top: this.$root.designerItems[side][0].span.top,
          'z-index': 4,
          height: this.$root.designerItems[side][0].span.height,
          width: this.$root.designerItems[side][0].span.width
        };
    },
    getSublimationImageHeight: function(side) {
      if (this.$root.designerItems[side].length > 0)
        return this.$root.designerItems[side][0].span.height;
      return 0;
    },
    getSublimationImageWidth: function(side) {
      if (this.$root.designerItems[side].length > 0)
        return this.$root.designerItems[side][0].span.width;
      return 0;
    },
    setSublimationImageStyle: function(left, top, side) {
      if (this.$root.designerItems[side].length > 0) {
        this.$root.designerItems[side][0].span.left = left;
        this.$root.designerItems[side][0].span.top = top;
        this.$root.designerItems[side][0].imageData.left = left;
        this.$root.designerItems[side][0].imageData.top = top;
      }
    },
    showSublimationControls: function(side) {
      return (this.$root.designerItems[side].length > 0);
    },
    bringSublimationImageToFront: function(side) {
      $('.view-sublimation-' + side).find(".modelImage").css({ 'z-index': 3, opacity: 1 });
      $('.view-sublimation-' + side).find(".sublimation-controls").css('z-index', 0);
      $('.view-sublimation-' + side).find('.sublimation-image').css({ 'z-index': 1, opacity: 1 });
    },
    sendSublimationImageToBack: function(side, event) {
      $('.view-sublimation-' + side).find(".modelImage").css({ 'z-index': 1, opacity: 1 });
      $('.view-sublimation-' + side).find('.sublimation-image').css({ 'z-index': 3, opacity: .50 });
      $('.view-sublimation-' + side).find(".sublimation-controls").css('z-index', 4);
      $('.view-sublimation-' + side).find('.modelImage').trigger('mouseup', true);
      $('.view-sublimation-' + side).find('.bleed-area').trigger('mouseup', true);
      $('.view-sublimation-' + side).find('.sublimation-image').trigger(event);
    },
    getBleedAreaStyle: function(side) {
      var productObj = this.$root.selectedProduct;
      if (productObj != null) {
        if (side == 'front') {
          return {
            height: productObj.dimensions.front.offsets.height,
            width: productObj.dimensions.front.offsets.width,
            left: productObj.dimensions.front.offsets.left,
            top: productObj.dimensions.front.offsets.top,
            'z-index': 3,
            'border-style': 'dashed',
            'border-width': '1px',
            position: 'absolute',
            cursor: 'move'
          };
        } else {
          return {
            height: productObj.dimensions.back.offsets.height,
            width: productObj.dimensions.back.offsets.width,
            left: productObj.dimensions.back.offsets.left,
            top: productObj.dimensions.back.offsets.top,
            'z-index': 3,
            'border-style': 'dashed',
            'border-width': '1px',
            position: 'absolute',
            cursor: 'move'
          };
        }
      }
    },
    isPhoneCase: function() {
      return this.$root.isPhoneCaseProduct();
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/designer_tab/designArea.js